import useTokenQuery from 'hooks/useTokenQuery';
import { PropsWithChildren, useMemo } from 'react';

import { ApiClientContext, createApiClient } from './ApiClientContext';

export function ApiClientProvider({ children }: PropsWithChildren) {
  const { data: accessToken } = useTokenQuery();
  const apiClient = useMemo(() => createApiClient(accessToken), [accessToken]);
  return <ApiClientContext.Provider value={apiClient}>{children}</ApiClientContext.Provider>;
}
